import { render, staticRenderFns } from "./GeneralPrinciple.vue?vue&type=template&id=22ec80a0&scoped=true"
import script from "./GeneralPrinciple.vue?vue&type=script&lang=js"
export * from "./GeneralPrinciple.vue?vue&type=script&lang=js"
import style0 from "./GeneralPrinciple.vue?vue&type=style&index=0&id=22ec80a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ec80a0",
  null
  
)

export default component.exports